// 内容审核 - 展示格式化工具
import type { LexiconResult, MachineTag } from './types'

export interface HighlightSegment {
  text: string
  hit: boolean
}

// 将原文按命中词切分为片段，用于模板渲染命中高亮（不使用 v-html）
export function highlightSegments(content: string, hitTerm: string): HighlightSegment[] {
  const keyword = hitTerm.trim()
  if (!keyword) return [{ text: content, hit: false }]
  const segments: HighlightSegment[] = []
  let cursor = 0
  let index = content.indexOf(keyword, cursor)
  while (index >= 0) {
    if (index > cursor) segments.push({ text: content.slice(cursor, index), hit: false })
    segments.push({ text: keyword, hit: true })
    cursor = index + keyword.length
    index = content.indexOf(keyword, cursor)
  }
  if (cursor < content.length) segments.push({ text: content.slice(cursor), hit: false })
  return segments.length ? segments : [{ text: content, hit: false }]
}

// 机审标签色调映射（全局样式 .tag-chip.tag-tone-*）
const MACHINE_TAG_TONES: Record<MachineTag, string> = {
  POLITICS: 'red',
  PORN: 'pink',
  TERROR: 'orange',
  ILLEGAL: 'maroon',
  ABUSE: 'purple',
  FINANCE: 'blue',
  AD: 'teal',
  SPAM: 'gray',
  VALUES: 'green'
}

export function machineTagTone(tag: MachineTag) {
  return MACHINE_TAG_TONES[tag] ?? 'gray'
}

// 词库识别结果 → 结果标签色调 class（全局样式 .result-tag.result-*）
export function lexiconResultClass(result: LexiconResult) {
  return { VIOLATION: 'result-violation', SUSPECTED: 'result-suspected', ALLOW: 'result-allow' }[result]
}
